import { setInitialState } from "../../../../utils/reducerOperations";
export function InitialState() {
  return {
    exploreTopicCommentsApi: setInitialState(),
  };
}